<script setup>
import fenixLogo from "@/assets/fenix-logo.png";

const props = defineProps({
  className: {
    type: String,
    default: "",
  },
  size: {
    type: String,
    default: "md",
    validator: (value) => ["sm", "md", "lg", "xl", "2xl"].includes(value),
  },
});

const sizeClasses = {
  sm: "h-10",
  md: "h-12",
  lg: "h-16",
  xl: "h-24",
  // 2xl is used as the landing header brand; needs to scale down on
  // mobile (the header itself is only h-24 = 96px below lg, so a
  // h-32 = 128px logo overflows it visibly).
  "2xl": "h-14 lg:h-32",
};
</script>

<template>
  <a href="/" :class="['flex items-center', props.className]">
    <img 
      :src="fenixLogo" 
      alt="Fenix Guardian Monitor" 
      :class="[sizeClasses[props.size], 'w-auto object-contain']"
    />
  </a>
</template>
